import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteComponent } from '../quote/quote.component';
import { QuoteSource } from '../quote-source.enum';
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { QuoteService } from '../quote.service';
import { Quote } from '../quote';
import {ImportExportComponent} from "@app/_components/_helpers/import-export/import-export.component";
import {Location} from "@angular/common";
import {EditQuoteComponent} from "@app/_components/quote/edit-quote/edit-quote.component";
import { Table } from 'primeng/table';
import { ReservationService } from '@app/_components/reservation';
import * as moment from 'moment';

@Component({
    selector: 'app-quote-list',
    templateUrl: './quote-list.component.html',
    styleUrls: ['./quote-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class QuoteListComponent implements OnInit {
	constructor(
		private quoteService: QuoteService,
		private alertService: AlertService,
		private messageService: MessageService,
		public reservationService: ReservationService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
    private location1: Location
	) {
		this.statuses = quoteService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@ViewChild('pt') pt: Table;
	quotes: any;
	quote: Quote;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'quoteId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
	];
  searchName: any;
  @ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;

	ngOnInit(): void {
		this.location1.go('/quote-list');
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.quoteId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			// Ensure filters object is always initialized
			if (!event.filters) {
				event.filters = {};
			}

			 // Clean up filters if their values are null
			 if (event.filters['quoteVO.sendEmail']?.value === null) {
				delete event.filters['quoteVO.sendEmail'];
			  }
			  if (event.filters['quoteVO.sendText']?.value === null) {
				delete event.filters['quoteVO.sendText'];
			  }

			if (event.filters['quoteVO.checkInDateTime']?.value) {
				event.filters['quoteVO.checkInDateTime'].value = moment(event.filters['quoteVO.checkInDateTime'].value).format('MM/DD/YYYY');
			}

			if (event.filters['quoteVO.checkOutDateTime']?.value) {
				event.filters['quoteVO.checkOutDateTime'].value = moment(event.filters['quoteVO.checkOutDateTime'].value).format('MM/DD/YYYY');
			}

			if (event.filters['quoteVO.quoteExpirationDateTime']?.value) {
				event.filters['quoteVO.quoteExpirationDateTime'].value = moment(event.filters['quoteVO.quoteExpirationDateTime'].value).format('MM/DD/YYYY');
			}

			 // If filters are empty, reset them to an empty object
			 if (Object.keys(event.filters).length === 0) {
				event.filters = {};
			 }

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-quote-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.quoteService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.quotes = res.data.quoteDetails;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						this.loading = false;
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { 
						// Ensure filters are properly structured (never undefined)
						if (!event.filters['quoteVO.sendEmail']) {
							event.filters['quoteVO.sendEmail'] = { value: null };
						}
						if (!event.filters['quoteVO.sendText']) {
							event.filters['quoteVO.sendText'] = { value: null };
						}
						this.loading = false;
					 }
				);

			if (this.datasource) {
				this.quotes = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit1(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(quote: Quote) {
		try {
			this.formLoading = true;
			this.quoteService.update(quote)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.quotes.map((quote, i) => {
							if (quote.quoteId === res.data.quote.quoteId) {
								this.quotes[i] = res.data.quote;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(quote: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(quote));

			this.formLoading = true;
			this.quoteService.delete(quote.quoteId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.quotes.splice(this.quotes.indexOf(quote), 1);
						this.recordTotal = this.quotes.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Quote ' + quote.quoteId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Quote ' + quote.quoteId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "120vw";
		dialogConfig.width = "75vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Quote',
			// Tag source so the Quote Analytics dashboard knows this quote came
			// from a manual create on the Quote List page (not best-fit / inbox).
			source: QuoteSource.QUOTE_LIST
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(QuoteComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			(payload: any) => {
				console.log('Dialog output:', payload);

				// Close the dialog FIRST so the dialog's scoped MessageService is
				// destroyed before we show our own toast — otherwise the two toasts
				// would compete and the dialog-level one vanishes immediately.
				dialogRef.close();

				// payload is either a plain string (legacy) or { message, quoteId }
				const message  = typeof payload === 'string' ? payload : payload?.message;
				const quoteId  = typeof payload === 'string' ? null    : payload?.quoteId;

				// Show success toast at the parent level so it survives the dialog close.
				this.messageService.add({ severity: 'info', summary: '📨 Quote Saved', detail: message, life: 8000 });

				// Reload the list so the newly-created quote appears in the table.
				this.ngOnInit();

				// The quote email is sent asynchronously (fire-and-forget) so the HTTP
				// 200 response arrives before SendGrid has been called.  Poll for the
				// delivery outcome after ~5 seconds; if it failed, show a sticky error
				// toast so the agent knows to resend or contact the guest directly.
				if (quoteId) {
					setTimeout(() => {
						this.quoteService.getEmailStatus(quoteId).subscribe((res: any) => {
							const status = res?.data?.emailStatus?.emailSendStatus;
							if (status === 4) {
								const errorDetail = res?.data?.emailStatus?.emailSendStatusMsg
									|| 'The email could not be delivered to the guest.';
								this.messageService.add({
									severity: 'error',
									summary: '⚠️ Email Delivery Failed',
									detail: errorDetail,
									life: 0  // sticky — must be manually dismissed
								});
							}
						});
					}, 5000);
				}
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit1(quote: Quote) {
    const dialogConfig = new MatDialogConfig();
    this.quoteService.findById(quote.quoteId).subscribe(res => {


      // settings
      dialogConfig.disableClose = false;
      dialogConfig.autoFocus = true;
      dialogConfig.hasBackdrop = true;
	  dialogConfig.maxWidth = "120vw";
	  dialogConfig.width = "75vw";
      dialogConfig.panelClass = "edit-order-mobile";

      // pass data, ie rateBuicket: this.shortTermRentalId,
      dialogConfig.data = {
        quote: this.mapSourceToTarget(res?.data?.quote),
        showCloseButton: true,
        title: 'Edit Quote'
      };

      // open the popup and get a reference to it called dialogRef
      const dialogRef = this.dialog.open(QuoteComponent, dialogConfig);
      this.location1.go('/quote/' + quote.quoteId);
      // to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
      dialogRef.componentInstance.doUpdate.subscribe(
        data => {
          console.log('Dialog output:', data);

          // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        //   this.updateQuoteCB(data);
		this.ngOnInit()

          // close the dialogBox
          dialogRef.close();
        });

      dialogRef.componentInstance.doDelete.subscribe(
        data => {
          console.log('Dialog output:', data);

          // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
          this.deleteQuoteCB(data);

          // close the dialogBox
          dialogRef.close();
        });
    });


	}

  mapSourceToTarget(source: any): any {
    return {
      quoteId: source.quoteId,
	  createDate: source.createDate,
	  lastUpdate: source.lastUpdate,
	  quoteIdMask: source.quoteIdMask,
      shortTermRentalId: source.shortTermRentalId,
      numAdults: source.numAdults,
      numChildren: source.numChildren,
      numQuoteStatus: source.quoteDetailAPIList && source.quoteDetailAPIList[0]?.quoteStatus, // Assuming a mapping logic
      checkOutDate: source.checkOutDateTime || "",
      quoteExpirationDateTime: source.quoteExpirationDateTime || "",
      checkInDate: source.checkInDateTime || "",
      guestNotes: source.guestNotes,
      opsNotes: source.opsNotes,
      sendEmail: source.sendEmail,
      sendText: source.sendText,
      guestMasterProfileId: source.guestMasterProfileId,
      reservationistUserId: source.reservationistUserId,
      guestProfile: {
        guestMasterProfileId: source.guestMasterProfileAPI.guestMasterProfileId?.toString() || "",
        firstName: source.guestMasterProfileAPI.firstName || null,
        lastName: source.guestMasterProfileAPI.lastName || null,
        emailAddress: source.guestMasterProfileAPI.emailAddress || "",
        guestCompanions: [],
        mobilePhone: source.guestMasterProfileAPI.mobilePhone || "",
      },
      selectedProperties: source.quoteDetailAPIList,
    };
  }

	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addQuoteCB(quote: Quote) {
		console.log('Adding Quote: ' + JSON.stringify(quote));
		// if we don't have a quotes array yet...
		if (!this.quotes) {
			this.quotes = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.quotes.unshift(quote);

		// no idea what this is but it is required to update the array
		this.quotes = [...this.quotes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quote ' + quote.quoteId + ' Added', life: 3000 });
	}

	updateQuoteCB(quote: Quote) {
		console.log('Updating Quote: ' + JSON.stringify(quote));
		let itemIndex = this.quotes.findIndex((item: any) => item.quoteId === quote.quoteId);
		this.quotes[itemIndex] = quote;

		// no idea what this is but it is required to update the array
		this.quotes = [...this.quotes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quote ' + quote.quoteId + ' Updated', life: 3000 });
	}

	deleteQuoteCB(quote: Quote) {
		console.log('Removing Quote: ' + quote);
		this.quotes.splice(this.quotes.indexOf(quote), 1);
		this.recordTotal = this.quotes.length;

		// no idea what this is but it is required to update the array
		this.quotes = [...this.quotes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Quote ' + quote.quoteId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.quotes ? this.first === (this.quotes.length - this.rows) : true; }
	isFirstPage(): boolean { return this.quotes ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(quote: any) {
		if (quote?.status) {
			const status = this.statuses.find((e: any) => e.value == quote.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		this.pt.clear();
	}

	getQuoteStatusName(quoteStatus)
	{
		if(quoteStatus != null)
		{
			return this.reservationService.quoteStatuses.find(function (item) { return item.value === quoteStatus}).name;
		}
		else
		{
			return '';
		}
	}

	showPaginator()
	{
		return true;
	}

  exportSelected(exporttype: any) {
    this.importExportComponent.exporData(exporttype, this.quotes, 'Quotes Info');
  }

  getDateTimeBasedOnTimeZone(date: any){
		return moment.utc(date).toDate()
	}

}
